// eslint-disable-next-line @typescript-eslint/naming-convention
export const SendToTypeEnum = {
	empty: 0,
	orthoLab: 1,
	restoLab: 2,
	chairsideGlidewell: 3,
	chairsideExocad: 4,
	midcOnly: 5,
	realGUIDE: 6,
	sprintRay: 7
} as const;

export type SendToTypeEnum = (typeof SendToTypeEnum)[keyof typeof SendToTypeEnum];

// PAY ATTENTION!!! THESE IDS ARE NOT SENT TO BACKEND (THEY ARE USED ONLY FOR RECOGNIZING "SENDTO" UI OPTIONS)
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SendToIdForNotLabsEnum = {
	glidewell: -999,
	exocad: -1000,
	midcOnly: -1001,
	realGUIDE: -1002,
	sprintRay: -1003
} as const;
export type SendToIdForNotLabsEnum = (typeof SendToIdForNotLabsEnum)[keyof typeof SendToIdForNotLabsEnum];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ShipToForNotLabsEnum = {
	midcOnly: -1
} as const;
export type ShipToForNotLabsEnum = (typeof ShipToForNotLabsEnum)[keyof typeof ShipToForNotLabsEnum];
